var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowMenuOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22 13.42L5.4 14.6L12 7.99998L5.4 1.39998L4.22 2.57998L9.64 7.99998L4.22 13.42Z",
    fill: "#575E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMenuOpen);
export default __webpack_public_path__ + "static/media/arrow_menu_open.1a53ef41863214c43d07ff9d52341ddb.svg";
export { ForwardRef as ReactComponent };